import React from 'react'

/* Style */
import './Champ.css'

/* Modules */
import { Link } from 'react-router-dom'
import { Breadcrumb, Modal, Spin, Button, Select, Input } from 'antd'

/* Components */
import TopBar from '../topBar/TopBar';
import RegistrationForm from '../shared/registrationForm/RegistrationForm';
import TeamList from '../shared/teamList/TeamList';

const ChampView = (props) => {
    return (
        <div id='champContent'>

            <TopBar />
            <div style={{ height: '70px' }}></div>

            <div className="champsBlock">
                <Breadcrumb>
                    <Breadcrumb.Item><Link to={'/home'}>Início</Link></Breadcrumb.Item>
                    <Breadcrumb.Item>
                        <Link to={{ pathname: '/home/champs', state: { userType: props.userType } }}>
                            Campeonatos
                        </Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>{props.champObject.nome}</Breadcrumb.Item>
                </Breadcrumb>
            </div>

            {!props.userType ?
                <Spin style={{ width: '100%' }} /> :
                <div className='HomeContent'>
                    <div className='HomeCard' style={{ marginLeft: 'inherit', display: props.userType === 'mesa' ? 'none' : null }}>
                        <a
                            onClick={() => props.openGeneralInfoDialog()}
                            style={{ color: 'rgba(0,0,0,0.65)' }}
                        >
                            <i className="fas fa-info" style={{ cursor: 'pointer' }}></i>
                            <div className='HomeCardTitle'>Informações Gerais</div>
                        </a>
                    </div>

                    <div className='HomeCard' style={{ marginLeft: 'inherit', display: props.userType === 'mesa' ? 'none' : null }}>
                        <a
                            onClick={() => props.openModalRegistration()}
                            style={{ color: 'rgba(0,0,0,0.65)' }}
                        >
                            <i className="fas fa-user-edit" style={{ cursor: 'pointer' }}></i>
                            <div className='HomeCardTitle'>Inscrição</div>
                        </a>
                    </div>

                    <div className='HomeCard' style={{ marginLeft: 'inherit', display: props.userType === 'mesa' ? 'none' : null }}>
                        <Link
                            to={{ pathname: '/home/champs/' + props.champObject.__key + '/weighing', state: { __key: props.champObject.__key } }}
                            style={{ color: 'rgba(0,0,0,0.65)' }}
                        >
                            <i className="fas fa-balance-scale"></i>
                            <div className='HomeCardTitle'>Pesagem</div>
                        </Link>
                    </div>

                    <div className='HomeCard' style={{ marginLeft: 'inherit', display: props.userType === 'mesa' ? 'none' : null }}>
                        <Link
                            to={{ pathname: '/home/champs/' + props.champObject.__key + '/search-competitor', state: { __key: props.champObject.__key } }}
                            style={{ color: 'rgba(0,0,0,0.65)' }}
                        >
                            <i className="fas fa-search"></i>
                            <div className='HomeCardTitle'>Consulta</div>
                        </Link>
                    </div>

                    <div className='HomeCard' style={{ marginLeft: 'inherit', display: props.userType === 'mesa' ? 'none' : null }}>
                        <a
                            onClick={() => props.openModalTeam()}
                            style={{ color: 'rgba(0,0,0,0.65)' }}
                        >
                            <i className="fas fa-users"></i>
                            <div className='HomeCardTitle'>Cadastrar equipe</div>
                        </a>
                    </div>

                    <div className='HomeCard' style={{ marginLeft: 'inherit', display: props.userType === 'mesa' ? 'none' : null }}>
                        <Link
                            to={{ pathname: '/home/champs/' + props.champObject.__key + '/switching' }}
                            style={{ color: 'rgba(0,0,0,0.65)' }}
                        >
                            <i className="fas fa-sitemap"></i>
                            <div className='HomeCardTitle'>Chaveamentos</div>
                        </Link>
                    </div>

                    <div className='HomeCard' style={{ marginLeft: 'inherit', display: props.userType === 'mesa' ? 'none' : null }}>
                        <Link
                            to={{ pathname: '/home/champs/' + props.champObject.__key + '/rotation' }}
                            style={{ color: 'rgba(0,0,0,0.65)' }}
                        >
                            <i className="fas fa-random"></i>
                            <div className='HomeCardTitle'>Rodízios</div>
                        </Link>
                    </div>

                    <div className='HomeCard' style={{ marginLeft: 'inherit' }}>
                        <Link
                            to={{ pathname: '/home/champs/' + props.champObject.__key + '/confrontation' }}
                            style={{ color: 'rgba(0,0,0,0.65)' }}
                        >
                            <i className="fas fa-chess"></i>
                            <div className='HomeCardTitle'>Confrontos</div>
                        </Link>
                    </div>
                </div>
            }

            <div style={{ height: '50px', clear: 'both' }}></div>

            {/* General Info Modal */}
            <Modal
                title="Informações gerais"
                visible={props.generalInfoDialog}
                onCancel={props.closeGeneralInfoDialog}
                footer={[
                    <Button key='save' loading={props.setGeneralInfoButton} onClick={props.setGeneralInfo}>Salvar</Button>,
                    <Button key='close' onClick={props.closeGeneralInfoDialog}>Fechar</Button>,
                ]}
            >
                {props.loadingGeneralInfo ? <Spin style={{ width: '100%', marginTop: '20px' }} /> :
                    <div>
                        <div style={{ float: 'left', width: '60%', textAlign: 'right' }}>Periodo de inscrição</div>
                        <Select
                            showSearch
                            placeholder="Perido de inscrição"
                            className='sharedInput'
                            style={{ marginBottom: '20px', marginLeft: '5%', float: 'left', width: '35%' }}
                            optionFilterProp="children"
                            defaultValue={props.generalInfoRegistrationStatus}
                            onChange={props.registrationStatus}
                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        >
                            <Select.Option value={null}> </Select.Option>
                            <Select.Option value='inProgress'>Em andamento</Select.Option>
                            <Select.Option value='finish'>Finalizadas</Select.Option>
                        </Select>

                        <div style={{ float: 'left', width: '60%', textAlign: 'right' }}>Confrontos simultâneos</div>
                        <Input
                            placeholder="Número de confrontos simultâneos"
                            className='sharedInput browser-default'
                            style={{ marginBottom: '20px', marginLeft: '5%', float: 'left', width: '35%' }}
                            defaultValue={props.generalInfoConfrontationPerTime}
                            type='number'
                            onKeyUp={input => props.addGeneralInfoFieldValue('confrontationPerTime', input.target.value)}
                        />

                        <div style={{ float: 'left', width: '60%', textAlign: 'right' }}>Tempo por confronto (min)</div>
                        <Input
                            placeholder="Tempo médio por confronto (em minutos)"
                            className='sharedInput browser-default'
                            style={{ marginBottom: '20px', marginLeft: '5%', float: 'left', width: '35%' }}
                            defaultValue={props.generalInfoConfrontationTime}
                            type='number'
                            onKeyUp={input => props.addGeneralInfoFieldValue('confrontationTime', input.target.value)}
                        />

                        <div style={{ float: 'left', width: '60%', textAlign: 'right' }}>Hora do início do campeonato</div>
                        <Input
                            placeholder="Hora do início do campeonato (informe um valor inteiro)"
                            className='sharedInput browser-default'
                            style={{ marginBottom: '20px', marginLeft: '5%', float: 'left', width: '35%' }}
                            defaultValue={props.generalInfoStartChamp}
                            type='number'
                            onKeyUp={input => props.addGeneralInfoFieldValue('startChamp', input.target.value)}
                        />
                    </div>
                }

                <div style={{ clear: 'both' }}></div>
            </Modal>

            {/* Registration Modal */}
            <Modal
                title={'Inscrição | ' + props.champObject.nome}
                visible={props.modalRegistration}
                onCancel={props.closeModalRegistration}
                width='600px'
                footer={[
                    // <Button key='close' onClick={props.closeModalRegistration}>Fechar</Button>
                ]}
            >
                <RegistrationForm
                    arrayOfTeams={props.arrayOfTeams}
                    champInfo={props.champObject}
                    quadroDePesos={props.quadroDePesos}
                />
            </Modal>

            {/* Team Modal */}
            <Modal
                title='Equipes'
                visible={props.modalTeam}
                onCancel={props.closeModalTeam}
                footer={[
                    <Button key='cancel' onClick={props.closeModalTeam}>Fechar</Button>
                ]}
            >
                <TeamList />
            </Modal>
        </div>
    )
}

export default ChampView